import React, { FC } from 'react';

import MediaContentItem from './MediaContentItem';
import { MediaContentProps } from './types';

const MediaContent: FC<MediaContentProps> = ({
  handleImageDelete,
  selectedImageUrl,
  onSelectImage,
  searchQuery,
  images = [],
  onDoubleClick,
  setIsCopying,
  forceType
}) => {
  const filteredImages = images.filter(
    ({ name, type }) =>
      name.toLowerCase().includes(searchQuery.toLowerCase()) &&
      (forceType ? type === forceType : true)
  );

  return (
    <div className="overflow-y-scroll max-h-[500px]">
      <div className="grid grid-cols-4 gap-2 my-4">
        {[...filteredImages]
          .reverse()
          .map(({ name, url, type, mediaId, mimeType }, i) => (
            <MediaContentItem
              handleImageDelete={handleImageDelete}
              name={name}
              url={url}
              type={type}
              mediaId={mediaId}
              mimeType={mimeType}
              key={i}
              isSelected={selectedImageUrl === url}
              onSelect={() => onSelectImage(url)}
              onDoubleClick={onDoubleClick}
              setIsCopying={setIsCopying}
            />
          ))}
      </div>
    </div>
  );
};

export default MediaContent;
